
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type StubSearchPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function StubSearchPageRT(): TemplateResult<StubSearchPageRTRootProps> {
    return _createElement('div', {});
}
        export const componentNames = []